import { useQuery, QueryFunction } from 'react-query';
import { WasteCode, getAllWasteCodes, GetWasteCodesQueries, getWasteCodeById } from '../../services/apiSLTP/materials/wasteCodes';

type UseWasteCodesQueryOptions = {
    queries?: GetWasteCodesQueries;
};

const getWasteCodes: QueryFunction<WasteCode[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseWasteCodesQueryOptions];
    const { queries } = options;

    const response = await getAllWasteCodes(queries);
    return response.data;
};

export const useWasteCodesQuery = (options: UseWasteCodesQueryOptions = {}) => {
    return useQuery(['wasteCodes', options], getWasteCodes);
};

type UseWasteCodeByIdQueryOptions = {
    wasteCodeId: string;
    enabled?: boolean;
};

const getWasteCodeByIdQuery: QueryFunction<WasteCode> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseWasteCodeByIdQueryOptions];
    const { wasteCodeId } = options;

    const response = await getWasteCodeById(wasteCodeId);
    return response.data;
};

export const useWasteCodeByIdQuery = (options: UseWasteCodeByIdQueryOptions) => {
    return useQuery(['wasteCode', options], getWasteCodeByIdQuery, {
        enabled: options.enabled !== false && !!options.wasteCodeId,
    });
};
